import { writable } from 'svelte/store';

export const chat_count = writable(0);